import * as Sports from '../../../../constants/SportType';
import SoccerStatistics from './Soccer.jsx';
import TennisStatistics from './Tennis.jsx';
import IceHockeyStatistics from './IceHockey.jsx';
import BasketballStatistics from './Basketball.jsx';
import BeachVolleyStatistics from './BeachVolley.jsx';
import VolleyballStatistics from './Volleyball.jsx';
import TableTennisStatistics from './TableTennis.jsx';
import BadmintonStatistics from './Badminton.jsx';
import CyberSportsStatistics from './CyberSports.jsx';
import Generic from './Generic.jsx';
export default function (sportId) {
    switch (sportId) {
        case Sports.FOOTBALL:
            return SoccerStatistics;
        case Sports.TENNIS:
            return TennisStatistics;
        case Sports.ICE_HOCKEY:
            return IceHockeyStatistics;
        case Sports.BASKETBALL:
            return BasketballStatistics;
        case Sports.BEACH_VOLLEYBALL:
            return BeachVolleyStatistics;
        case Sports.VOLLEYBALL:
            return VolleyballStatistics;
        case Sports.TABLE_TENNIS:
            return TableTennisStatistics;
        case Sports.BADMINTON:
            return BadmintonStatistics;
        case Sports.CYBER_SPORTS:
            return CyberSportsStatistics;
        default:
            return Generic;
    }
}



// WEBPACK FOOTER //
// ./src/components/grid/event/statistics/statisticsComponentFactory.js